// Free tier limits configuration
import type { FreeTierLimits } from '../types'

// Parse diagnostic test codes from environment variable
const parseDiagnosticTestCodes = (): string[] => {
  const envValue = import.meta.env.VITE_FREE_DIAGNOSTIC_TEST_CODES || ''
  if (!envValue) return []
  return envValue.split(',').map((code: string) => code.trim()).filter(Boolean)
}

export const FREE_TIER_LIMITS: FreeTierLimits = {
  maxQuestionsPerExam: 5,
  allowedTestCodes: parseDiagnosticTestCodes(),
}

// Where students buy a test series (book + activation key)
export const BUY_TEST_SERIES_URL = 'https://myneetbuddy.com/'

// Razorpay configuration
export const RAZORPAY_KEY_ID = import.meta.env.VITE_RAZORPAY_KEY_ID || ''

// Payment-related constants
export const PAYMENT_CONSTANTS = {
  CURRENCY: 'INR',
  COMPANY_NAME: 'My NEET Buddy',
  THEME_COLOR: '#2563EB', // Blue-600
}

// LocalStorage keys
export const STORAGE_KEYS = {
  PYQ_PROGRESS: 'pyq_progress',
}

// Re-engagement configuration
export const RE_ENGAGEMENT_CONFIG = {
  // Days after which to show re-engagement prompt
  DAYS_THRESHOLD: 2,
  // Milliseconds in a day
  MS_PER_DAY: 24 * 60 * 60 * 1000,
}
